import {
	Alert,
	Box,
	Chip,
	CircularProgress,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import type { ConversionMapping } from '../../../../schemas/provinceConversion';

export interface ConversionMappingsTableProps {
	mappings: ConversionMapping[] | undefined;
	isLoading: boolean;
	isError: boolean;
}

const LOAI_LABEL: Record<ConversionMapping['loai'], string> = {
	RENAME: 'Đổi mã',
	MERGE: 'Sáp nhập',
};

export function ConversionMappingsTable({ mappings, isLoading, isError }: ConversionMappingsTableProps) {
	if (isLoading) {
		return (
			<Box display="flex" justifyContent="center" p={4}>
				<CircularProgress />
			</Box>
		);
	}

	if (isError) {
		return <Alert severity="error">Không thể tải danh sách ánh xạ.</Alert>;
	}

	if (!mappings || mappings.length === 0) {
		return <Alert severity="info">Đợt này chưa có ánh xạ nào.</Alert>;
	}

	return (
		<TableContainer component={Paper} variant="outlined">
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell>Mã cũ</TableCell>
						<TableCell>Mã mới</TableCell>
						<TableCell>Tên mới</TableCell>
						<TableCell>Loại</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{mappings.map((mapping) => (
						<TableRow key={`${mapping.maCu}-${mapping.maMoi}`}>
							<TableCell>{mapping.maCu}</TableCell>
							<TableCell>{mapping.maMoi}</TableCell>
							<TableCell>{mapping.tenMoi}</TableCell>
							<TableCell>
								<Chip size="small" label={LOAI_LABEL[mapping.loai]} />
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
